import React from 'react';

const CtaSidebar = props => (
  <div>
    {props.cta ? (
      <div className="company-help-box text-center">
        <h3>{props.cta.ctaHeading}</h3>
        <p>{props.cta.ctaBody}</p>
        <a href={props.cta.ctaLink} className="bussiness-btn-larg">
          {props.cta.ctaTitle}
        </a>
      </div>
    ) : (
      ''
    )}
  </div>
);
export default CtaSidebar;



// WEBPACK FOOTER //
// ./src/components/CtaSidebar.js